import { Spinner } from "@carbon6/c6-frontend-design";
import { StatusChip } from "@/shared/ui/status";
import { formatDuration } from "@/shared/utils/datetime/format";
import { isProbeOpen, type Probe } from "../../domain/probe";
import { isProbeTakingLong } from "../../feature/probePolling";
import { probeStatusView } from "../../feature/probeStatus";
import styles from "./ProbeStateBanner.module.css";

type ProbeStateBannerProps = {
  probe: Probe;
  /** 경과 시간 계산의 기준 시각. 상위가 폴링 tick 마다 갱신한다. */
  nowMs: number;
};

/**
 * Probe 의 현재 상태 한 줄.
 *
 * **진행률 바를 만들지 않는다** — BE 가 퍼센트 · 바이트 · ETA · attempt 를 주지 않는다
 * (`ProbeResponse` 는 상태와 종료 필드뿐). 무한 spinner 와 경과 시간이 정직한 표현이다.
 */
export function ProbeStateBanner({ nowMs, probe }: ProbeStateBannerProps) {
  const view = probeStatusView(probe.state);
  const open = isProbeOpen(probe.state);
  const elapsedMs = Math.max(0, nowMs - probe.createdAtMs);

  return (
    <div className={styles.banner}>
      <div className={styles.headline}>
        {open ? <Spinner size="sm" label="진행 중" /> : null}
        <StatusChip tone={view.tone}>{view.label}</StatusChip>
        <p className={styles.description}>
          {view.description}
          {open ? ` (${formatDuration(elapsedMs)} 경과)` : null}
        </p>
      </div>
      {isProbeTakingLong(probe.state, elapsedMs) ? (
        <p className={styles.notice}>
          수집이 예상보다 길어지고 있습니다. Worker 가 재시도 중일 수 있으니 조금 더 기다려 주세요.
        </p>
      ) : null}
    </div>
  );
}
